import script from "./CanvasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvasPage.vue?vue&type=script&setup=true&lang=js"

import "./CanvasPage.vue?vue&type=style&index=0&id=3b325820&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b325820"]])

export default __exports__